import React, { useRef, useLayoutEffect } from "react";

import Icon from "./icons";
import UiChangelog from "./UiChangelog";
import MmChangelog from "./MmChangelog";
import { setNavbarHeightVariableValue, tabs } from "./utils";
import { useNavigate } from "react-router-dom";

function Nav({ latestStableRelease }) {
  const navRef = useRef(null);
  const navigate = useNavigate();

  console.log(latestStableRelease);

  useLayoutEffect(() => {
    setNavbarHeightVariableValue(navRef);
  }, []);

  return (
    <header>
      <nav className="navbar navbar-expand navbar-main fixed-top align-items-stretch">
        <a className="navbar-brand d-flex align-items-center" href="/">
          {Icon.logo} <span style={{ fontSize: '1.25rem', marginLeft: '0.5ch' }}>OBLAC Drives</span>
        </a>

        <ul className="navbar-nav gap-3 ms-3 me-auto">
          <li className="nav-item dropdown d-inline-flex align-items-center">
            <button
              type="button"
              className="nav-link dropdown-toggle h-100"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Releases
            </button>
            <div className="dropdown-menu shadow rounded-3 overflow-hidden">
              <h6 className="d-flex dropdown-header fw-bold">
                LATEST
                <span className="badge text-bg-brand ms-auto" style={{ height: '1.5em' }}>
                  v{latestStableRelease?.version}
                </span>
              </h6>
              <a
                className="d-flex dropdown-item text-nowrap"
                href={latestStableRelease?.windowsAppUrl}
              >
                Download for Windows
                <span className="ms-auto ps-3">{Icon.download}</span>
              </a>
              <a
                className="d-flex dropdown-item text-nowrap"
                href={latestStableRelease?.linuxAppUrl}
              >
                Download for Linux
                <span className="ms-auto ps-3">{Icon.download}</span>
              </a>
              <div className="dropdown-divider"></div>
              <a
                className="dropdown-item text-nowrap"
                href="#latest-stable-release"
              >
                View all releases
              </a>
            </div>
          </li>

          <li className="nav-item dropdown">
            <button
              type="button"
              className="nav-link dropdown-toggle h-100"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              SOMANET Software
            </button>
            <div className="dropdown-menu shadow rounded-3 overflow-hidden">
              {tabs.map(({ key, label }) => (
                <button
                  type="button"
                  className="dropdown-item text-nowrap"
                  onClick={() => navigate(`/latest/latest/${key}`)}
                  key={key}
                >
                  {label}
                </button>
              ))}
              <div className="dropdown-divider"></div>
              <MmChangelog />
              <UiChangelog />
            </div>
          </li>

          <li className="nav-item dropdown">
            <button
              type="button"
              className="nav-link dropdown-toggle h-100"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Documentation
            </button>
            <div className="dropdown-menu shadow rounded-3 overflow-hidden">
              <a
                href="https://synapticon.github.io/motion_master/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex dropdown-item text-nowrap"
              >
                Motion Master{" "}
                <span className="ms-auto ps-3">{Icon.linkExternal}</span>
              </a>
              <a
                href="https://synapticon.github.io/oblac/motion-master-api/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex dropdown-item text-nowrap"
              >
                HTTP API <span className="ms-auto ps-3">{Icon.linkExternal}</span>
              </a>
              <a
                href="https://synapticon.github.io/oblac/motion-master-client/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex dropdown-item text-nowrap"
              >
                Client library{" "}
                <span className="ms-1">{Icon.typescript}</span>
                <span className="ms-auto ps-3">{Icon.linkExternal}</span>
              </a>
              <button
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#whatAreOblacBundlesModal"
                className="dropdown-item text-nowrap"
              >
                OBLAC Bundles
              </button>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Nav;
